import { UserRoundX } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { getMyInvitations } from '../lib/api';
import { MyInvitations } from '../settings/People';
import { Button } from '../ui/Button';
import { useSession } from './session';
import { AuthFrame } from './SignedOut';

export function NoAccess() {
  const { signOut, signingOut, refresh } = useSession();
  // Invited by more than one workspace: they choose which to join (WRMM-133).
  const invited = (useQuery({ queryKey: ['my-invitations'], queryFn: ({ signal }) => getMyInvitations(signal) }).data?.length ?? 0) > 0;
  return (
    <AuthFrame>
      <div className="rounded-2xl border border-line bg-panel p-8 shadow-pop">
        <div className="flex size-11 items-center justify-center rounded-xl bg-sunken text-ink-2"><UserRoundX className="size-5" /></div>
        <h1 className="mt-5 text-xl font-semibold tracking-tight">You’re signed in, but not a member of any workspace</h1>
        <p className="mt-2 text-ink-2">{invited ? 'You’re invited to more than one workspace. Accept the one you mean to join; you can accept others later in Settings.'
          : 'An owner needs to give you access before you can see customers or devices. Once they have, check again.'}</p>
        {invited && <div className="mt-4"><MyInvitations /></div>}
        <div className="mt-6 flex gap-2">
          <Button variant="primary" onClick={refresh}>Check again</Button>
          <Button onClick={() => void signOut()} disabled={signingOut}>{signingOut ? 'Signing out…' : 'Sign out'}</Button>
        </div>
      </div>
    </AuthFrame>
  );
}
